import { render, staticRenderFns } from "./MarketplaceContractConfirm.vue?vue&type=template&id=2a885172&scoped=true&"
import script from "./MarketplaceContractConfirm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a885172",
  null
  
)

export default component.exports